/**
 * Production Performance uploaded Excel rows (per project) — Configuration Engine manage APIs.
 */
import { apiClient } from './baseApi';

const BASE = '/miter/production-performance';

export const productionTrackingRowsService = {
  listProjectsWithRows: async () => {
    const response = await apiClient.get(`${BASE}/tracking-rows/projects`);
    return response.data;
  },

  getRows: async (projectCode) => {
    const response = await apiClient.get(
      `${BASE}/${encodeURIComponent(projectCode)}/tracking-rows`
    );
    return response.data;
  },

  saveRows: async (projectCode, rows) => {
    const response = await apiClient.put(
      `${BASE}/${encodeURIComponent(projectCode)}/tracking-rows`,
      { rows }
    );
    return response.data;
  },

  deleteAllRows: async (projectCode) => {
    const response = await apiClient.delete(
      `${BASE}/${encodeURIComponent(projectCode)}/tracking-rows`
    );
    return response.data;
  },

  uploadExcel: async (projectCode, fileBase64) => {
    const response = await apiClient.post(
      `${BASE}/${encodeURIComponent(projectCode)}/upload`,
      { fileBase64 },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  },

  /**
   * Download Excel as a blob (Activity Code client format).
   */
  downloadExcel: async (projectCode) => {
    const response = await apiClient.get(
      `${BASE}/${encodeURIComponent(projectCode)}/tracking-rows/export`,
      { responseType: 'blob' }
    );
    return response.data;
  },
};
